import { render } from "./DeleteBlockComponent.vue?vue&type=template&id=2b302dc1&scoped=true"
import script from "./DeleteBlockComponent.vue?vue&type=script&lang=js"
export * from "./DeleteBlockComponent.vue?vue&type=script&lang=js"

import "./DeleteBlockComponent.vue?vue&type=style&index=0&id=2b302dc1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b302dc1"

export default script